import {
  getGetUserAiSupportedTasksQueryKey,
  useGetUserAiSupportedTasks,
  useGetTopAiSupportedTasks,
  getGetTopAiSupportedTasksQueryKey,
  likeAiSupportedTasks,
  unlikeAiSupportedTasks,
  useDeleteAiSupportedTasks,
} from "@packages/api/madlenAPI";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import { AiSupportedTasksResponseDto } from "@packages/api/madlenAPI.schemas";
import { Tool } from "../../components/tool_components/types";
import AiSupportedTasksCard from "@features/tools/components/ai-supported-tasks/AiSupportedTasksCard";
import { toolsList } from "@packages/utils";

interface ExtendedTool extends Tool {
  isEditable?: boolean;
}

const AiSupportedTaskDetailComponent = ({ tool }: { tool: ExtendedTool }) => (
  <AiSupportedTasksCard
    tool={tool as unknown as AiSupportedTasksResponseDto}
    isEditable={tool.isEditable}
  />
);

const AiSupportedTasksView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserAiSupportedTasks}
      useDeleteTool={useDeleteAiSupportedTasks}
      getGetToolsQueryKey={getGetUserAiSupportedTasksQueryKey}
      useGetTopTools={useGetTopAiSupportedTasks}
      likeTool={likeAiSupportedTasks}
      unlikeTool={unlikeAiSupportedTasks}
      getGetTopToolsQueryKey={getGetTopAiSupportedTasksQueryKey}
      toolType="aiSupportedTasks"
      toolPath="ai-supported-tasks"
      DetailComponent={AiSupportedTaskDetailComponent}
      colors={
        toolsList
          .flatMap((a) => a.tools)
          .find((tool) => tool.id === "ai-supported-tasks")?.colors!
      }
      toolColor="fuchsia"
      gradientColor="yellow"
    />
  );
};

export default AiSupportedTasksView;
